import React, { useState } from 'react';
import { Card, Typography, Popover, IconButton } from '@guildeducationinc/recess';
import InfoOutlinedIcon from '@guildeducationinc/recess/icons/InfoOutlinedIcon';
import { useEmployerContent } from '@src/context/EmployerContentContext';
import { clickable } from '@src/analytics';
import useECornellSSOLinks from '@src/hooks/useECornellSSOLinks';
import ErrorMessage from '@shared/ErrorMessage/ErrorMessage';
import Skeleton from '@shared/Skeleton/Skeleton';
import ECornellCard from './ECornellCard/ECornellCard';

const YourClasses: React.FC = () => {
  const { your_classes: content, error } = useEmployerContent();
  const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);
  const { data: ssoLinkData } = useECornellSSOLinks();

  const popoverClickable = () => {
    setIsPopoverOpen(true);
    clickable({
      product: 'home',
      loggedIn: true,
      tag: 'classes_tool_tip',
      text: 'tool_tip',
      type: 'action icon',
    });
  };
  // A user can only have one active eCornell enrollment at a time. This could potentially change in the future
  return (
    <Card id='your-classes'>
      <div className='flex flexItems--center'>
        <Typography variant='h2' className='padding--right_16'>
          <Skeleton>Your classes</Skeleton>
        </Typography>
        {content?.body && (
          <Popover
            id='your-classes-tooltip'
            onOutsideClick={() => setIsPopoverOpen(false)}
            popoverContent={content.body}
            show={isPopoverOpen}
            triggerRefProp='forwardRef'
          >
            <IconButton
              appearance='minimal'
              label='Your classes information'
              icon={<InfoOutlinedIcon size={32} />}
              onClick={popoverClickable}
            />
          </Popover>
        )}
      </div>

      <Card.Content style={{ marginTop: 16 }}>
        {error || content?.error ? (
          <ErrorMessage />
        ) : (
          <Skeleton>
            <ECornellCard
              ssoLink={ssoLinkData?.ssoLink}
              programName={ssoLinkData?.guildProgramName}
            />
          </Skeleton>
        )}
      </Card.Content>
    </Card>
  );
};

export default YourClasses;
